import React from 'react';
import ReactDOM from 'react-dom';

import './styles/index.scss';

import App from 'app';


const DOM_ID = 'react-app';

ReactDOM.render(
  <App />,
  document.getElementById(DOM_ID),
);
